import { useState, useEffect } from "react";
import { Box, Select, MenuItem, FormControl, InputLabel}  from '@mui/material';
import {getProductTypes} from '../services/products.js'

const TypeDropdown = ({selectedType, setSelectedType, isMobile}) => {
    const [types, setTypes] = useState([]);
    useEffect(()=>{
        const getData = async() => {
            const _types = await getProductTypes();
            setTypes([{label:'All', value: "All"}, ..._types])
        }
        getData();
    }, [])
    const handleChange = (e) => {
        setSelectedType(e.target.value)
        //setOpen(false)
    }
      return (
        <Box sx={isMobile ? {minWidth: 130, marginRight:'10px'} : {minWidth: 200, marginRight:'50px' }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedType}
                label="Type"
                onChange={handleChange}
                >
                {types.map((x, key)=><MenuItem  value={x.label} key={key}>{x.label}</MenuItem>)}
                </Select>
            </FormControl>
        </Box>
      )
}

export default TypeDropdown
